// @flow
import React, { Fragment } from 'react';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import styled, { type StyledComponent } from 'styled-components';

import { DSTokenMap, FontWeight, Spacing } from '@rover/kibble/styles';
import Checkbox from '@rover/react-lib/components/formFields/Checkbox';
import type { Address } from '@rover/react-lib/types';
import { getCityZipAddressLine, isValidAddress } from '@rover/react-lib/utils/address';

type Props = {
  onChange: (boolean) => void,
  address: Address,
  isChecked: boolean,
};

const AddressCard: StyledComponent<{}> = styled.div`
  background-color: ${DSTokenMap.BACKGROUND_COLOR_SECONDARY};
  padding: ${Spacing.M};
  margin-bottom: ${Spacing.M};
`;

const CheckboxContainer: StyledComponent<{}> = styled.div`
  display: flex;
  flex-direction: 'row';
`;

const CheckboxLabel: StyledComponent<{}> = styled.label`
  margin: 0;
  font-weight: ${FontWeight.BOLD};
`;

const AddressContainer: StyledComponent<{}> = styled.div`
  margin-left: ${Spacing.S};
`;

export const AddressLine: StyledComponent<{}> = styled.p`
  margin: 0;
`;

const checkBoxLabelString = t`Use my primary address as the billing address`;

const checkboxId = 'address-form-use-primary-checkbox';

const AddressCheckbox = ({ onChange, address, isChecked }: Props) => (
  <AddressCard>
    <CheckboxContainer>
      <Checkbox onChange={onChange} value="address" checked={isChecked} id={checkboxId} />
      <AddressContainer>
        <CheckboxLabel htmlFor={checkboxId}>
          <Trans id={checkBoxLabelString} />
        </CheckboxLabel>
        {isValidAddress(address) && isChecked && (
          <Fragment>
            <AddressLine>{address.addressLine1}</AddressLine>
            <AddressLine>{address.addressLine2}</AddressLine>
            <AddressLine>{getCityZipAddressLine(address)}</AddressLine>
          </Fragment>
        )}
      </AddressContainer>
    </CheckboxContainer>
  </AddressCard>
);

export default AddressCheckbox;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/AddressCheckbox.jsx